import { useOutletContext } from 'react-router-dom';
import type { CaseRequestWizardContextValue } from '../layouts/CaseRequestLayout';
import type { CriminalWizardContextValue } from '../layouts/CriminalRequestLayout';
import type { CivilAdviseWizardContextValue } from '../layouts/CivilAdviseRequestLayout';
import type { CivilLitigationWizardContextValue } from '../layouts/CivilLitigationRequestLayout';
import type { CriminalAppellateWizardContextValue } from '../layouts/CriminalAppellateRequestLayout';

import type { ExtraditionMlaWizardContextValue } from '../layouts/ExtraditionMlaRequestLayout';

import type { CivilAppellateWizardContextValue } from '../layouts/CivilAppellateRequestLayout';
import type { NominationWizardContextValue } from '../layouts/NominationRequestLayout';
import type { PublicPetitionWizardContextValue } from '../layouts/PublicPetitionRequestLayout';
import type { RightToInformationWizardContextValue } from '../layouts/RightToInformationRequestLayout';
import type { AttorneyGeneralWizardContextValue } from '../layouts/AttorneyGeneralRequestLayout';

export function useCaseRequestWizard() {
  return useOutletContext<CaseRequestWizardContextValue>();
}

export function useCriminalAppellateWizardContext(): CriminalAppellateWizardContextValue {
  return useCaseRequestWizard().criminalAppellate;
}

export function useCriminalWizardContext(): CriminalWizardContextValue {
  return useCaseRequestWizard().criminal;
}

export function useCivilAdviseWizardContext(): CivilAdviseWizardContextValue {
  return useCaseRequestWizard().civilAdvise;
}

export function useCivilLitigationWizardContext(): CivilLitigationWizardContextValue {
  return useCaseRequestWizard().civilLitigation;
}


export function useExtraditionMlaWizardContext(): ExtraditionMlaWizardContextValue {
  return useCaseRequestWizard().extraditionMla;
}
export function useCivilAppellateWizardContext(): CivilAppellateWizardContextValue {
  return useCaseRequestWizard().civilAppellate;
}

export function useNominationWizardContext(): NominationWizardContextValue {
  return useCaseRequestWizard().nomination;
}

export function usePublicPetitionWizardContext(): PublicPetitionWizardContextValue {
  return useCaseRequestWizard().publicPetition;}
export function useRightToInformationWizardContext(): RightToInformationWizardContextValue {
  return useCaseRequestWizard().rightToInformation;
}

export function useAttorneyGeneralWizardContext(): AttorneyGeneralWizardContextValue {
  return useCaseRequestWizard().attorneyGeneral;
}
